import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_da187197-cd0a-49f8-adf8-744b68840464/artifacts/ky3myote_Untitled%20design%20%289%29.png";

const courseLinks = [
  { name: "IBPS Clerk / PO", path: "/courses/ibps-clerk" },
  { name: "SBI Clerk / PO", path: "/courses/sbi-clerk" },
  { name: "SSC CGL", path: "/courses/ssc-cgl" },
  { name: "Railway NTPC", path: "/courses/railway-ntpc" },
  { name: "MAH MBA CET", path: "/courses/mah-mba-cet" },
  { name: "LIC AAO", path: "/courses/lic-aao" },
];

const quickLinks = [
  { name: "About Us", path: "/about" },
  { name: "All Courses", path: "/courses" },
  { name: "Book Demo Class", path: "/demo-class" },
  { name: "Study Material", path: "/study-material" },
  { name: "Gallery", path: "/gallery" },
  { name: "Notifications", path: "/notifications" },
  { name: "All Programs", path: "/programs" },
  { name: "Resources", path: "/resources" },
  { name: "FAQ", path: "/faq" },
  { name: "Contact Us", path: "/contact" },
];

const locationLinks = [
  { name: "Badlapur", slug: "badlapur" },
  { name: "Ambernath", slug: "ambernath" },
  { name: "Ulhasnagar", slug: "ulhasnagar" },
  { name: "Karjat", slug: "karjat" },
  { name: "Neral", slug: "neral" },
  { name: "Vangni", slug: "vangni" },
  { name: "Khopoli", slug: "khopoli" },
];

export const Footer = () => {
  return (
    <footer className="bg-vedanti-navy text-white relative" data-testid="footer">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-vedanti-orange via-vedanti-mango to-vedanti-orange"></div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,_rgba(249,115,22,0.05)_0%,_transparent_50%)]"></div>
      <div className="container-main py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <img src={LOGO_URL} alt="Vedanti Academy" className="h-28 w-auto mb-4 bg-white rounded-lg p-2.5" />
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Premier coaching for Banking, SSC, MBA CET, Railway & Government Exams.
              Trusted by 500+ students with 5-star Google rating.
            </p>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/vedantiacademy/" target="_blank" rel="noopener noreferrer nofollow" data-testid="footer-instagram" className="w-10 h-10 rounded-xl bg-gradient-to-br from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 flex items-center justify-center transition-all shadow-lg text-sm font-bold text-white">In</a>
              <a href="https://www.facebook.com/vedantiacademy/" target="_blank" rel="noopener noreferrer nofollow" data-testid="footer-facebook" className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 flex items-center justify-center transition-all shadow-lg text-sm font-bold text-white">Fb</a>
              <a href="https://www.youtube.com/@vedantiacademy" target="_blank" rel="noopener noreferrer nofollow" data-testid="footer-youtube" className="w-10 h-10 rounded-xl bg-gradient-to-br from-red-600 to-red-500 hover:from-red-700 hover:to-red-600 flex items-center justify-center transition-all shadow-lg text-sm font-bold text-white">Yt</a>
              <a href="https://wa.me/918308776505" target="_blank" rel="noopener noreferrer nofollow" data-testid="footer-whatsapp" className="w-10 h-10 rounded-xl bg-gradient-to-br from-green-500 to-green-400 hover:from-green-600 hover:to-green-500 flex items-center justify-center transition-all shadow-lg text-sm font-bold text-white">Wa</a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4 text-vedanti-mango">Quick Links</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-slate-300 text-sm hover:text-vedanti-orange transition-colors" data-testid={`footer-${link.name.toLowerCase().replace(/\s/g, "-")}`}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Popular Courses */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4 text-vedanti-mango">Popular Courses</h4>
            <ul className="space-y-2.5">
              {courseLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-slate-300 text-sm hover:text-vedanti-orange transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4 text-vedanti-mango">Contact Us</h4>
            <p className="text-slate-300 text-sm font-medium mb-4" data-testid="footer-full-name">
              Vedanti Academy - Banking, MBA CET, CAT, CGL, IBPS, MPSC, CSAT, UPSC, Clerk, PO Coaching Classes
            </p>
            <div className="space-y-4">
              <div className="flex gap-3">
                <MapPin size={18} className="text-vedanti-orange flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-medium">Badlapur Branch</p>
                  <p className="text-slate-300 text-sm">3rd Floor, Jadhav Market, above Aradhana Hotel, Badlapur, Maharashtra 421503</p>
                </div>
              </div>
              <a href="tel:+918308776505" className="flex gap-3 items-center hover:text-vedanti-orange transition-colors" data-testid="footer-phone">
                <Phone size={18} className="text-vedanti-orange flex-shrink-0" />
                <span className="text-sm">+91 8308776505</span>
              </a>
              <a href="mailto:vedantiacademy@gmail.com" className="flex gap-3 items-center hover:text-vedanti-orange transition-colors" data-testid="footer-email">
                <Mail size={18} className="text-vedanti-orange flex-shrink-0" />
                <span className="text-sm">vedantiacademy@gmail.com</span>
              </a>
              <div className="flex gap-3 items-center">
                <Clock size={18} className="text-vedanti-orange flex-shrink-0" />
                <span className="text-slate-300 text-sm">Mon-Sat: 8:00 AM - 8:00 PM</span>
              </div>
            </div>
          </div>
        </div>

        {/* Locations */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <h4 className="font-heading font-semibold text-sm text-vedanti-mango mb-3">Serving Students From</h4>
          <div className="flex flex-wrap gap-2">
            {locationLinks.map((loc) => (
              <Link key={loc.slug} to={`/locations/${loc.slug}`} className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-slate-300 hover:bg-vedanti-orange/20 hover:text-vedanti-orange transition-colors">
                {loc.name}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="container-main py-4 flex flex-col md:flex-row justify-between items-center gap-2 text-sm text-slate-400">
          <p>Copyright 2026 Vedanti Academy. All Rights Reserved.</p>
          <div className="flex gap-4">
            <Link to="/faq" className="hover:text-vedanti-orange transition-colors">FAQ</Link>
            <Link to="/contact" className="hover:text-vedanti-orange transition-colors">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
